import dayjs from "dayjs";
import React from "react";
import { NavLink } from "react-router-dom";
import Card from "src/components/UI/Card/Card";
import { MONTH_STR_MAP } from "src/constants/string-res-map";
import { useLocaleContext } from "src/context/locale-context";

export function FlightMonthsFilter({
  tripType,
  location,
  selectedPriceRange,
  priceEndRange,
  buildLinkFromFilter,
  expanded,
}) {
  const { getStringRes, currentLocale } = useLocaleContext();

  return (
    <Card opts={{ padding: 0, border: "none" }} className="filter-section results-grid-item">
      <ul className="flight-month-list">
        {Array.from({ length: 13 }, (_, i) => {
          const currentMonthIndex = new Date().getMonth();
          const monthIndex = i - 1;
          const currYear = dayjs().year();
          const todayUnix = dayjs().unix();
          if (i === 0) return [-1, null, null]; // any month
          else {
            const offset = currentMonthIndex + monthIndex < 12 ? 0 : 12;
            const mIndex = currentMonthIndex + monthIndex - offset;
            const year = offset ? currYear + 1 : currYear;
            const rStart = dayjs().set({ year, month: mIndex }).startOf("month").unix();
            return [
              mIndex,
              rStart > todayUnix ? rStart : todayUnix,
              dayjs().set({ year, month: mIndex }).endOf("month").startOf("day").unix(),
            ];
          }
        }).map(([mIndex, rStart, rEnd]) => (
          <li key={"filter-month-" + mIndex}>
            <NavLink
              to={buildLinkFromFilter(
                tripType,
                location.origin,
                location.destination,
                rStart,
                rEnd,
                selectedPriceRange[0] === priceEndRange[0] ? null : selectedPriceRange[0],
                selectedPriceRange[1] === priceEndRange[1] ? null : selectedPriceRange[1],
                currentLocale.split("_")[0]
              )}
              state={{ preExpanded: expanded }}
              preventScrollReset
              end>
              {mIndex < 0
                ? getStringRes("res.filter.date.norange")
                : getStringRes(MONTH_STR_MAP[mIndex])}
            </NavLink>
          </li>
        ))}
      </ul>
    </Card>
  );
}
